<template>
  <a-modal
    :visible="visible"
    title="取消"
    :confirm-loading="isConfirmCloseBtnLading"
    @ok="handleReject"
    @cancel="handleCancelClose"
  >
    <a-textarea placeholder="请填写取消原因" v-model="closeReason" :maxLength="200" :auto-size="{ minRows: 3, maxRows: 6 }" />
  </a-modal>
</template>

<script>
import { apiMesDiscreteJobsCancellation } from '@/api/mes/workOrderManage/workOrderDesk'

export default {
  name: 'CancelModal',
  data () {
    return {
      visible: false,
      isConfirmCloseBtnLading: false,
      closeReason: '',
      selectedRowKeys: [] // 勾选的数据
    }
  },
  methods: {
    show (data) {
      this.selectedRowKeys = data
      this.visible = true
      this.closeReason = ''
    },
    // 驳回
    handleReject () {
      if (!this.closeReason) {
        this.$message.warning('请填写取消原因')
        return
      }
      this.isConfirmCloseBtnLading = true
      apiMesDiscreteJobsCancellation({ ids: this.selectedRowKeys, cancelReason: this.closeReason }).then(res => {
        if (res?.code === 200) {
          this.$message.success('取消成功!')
          this.$emit('reSearch')
          this.visible = false
        }
      }).finally(() => {
        this.isConfirmCloseBtnLading = false
      })
    },
    // 取消
    handleCancelClose () {
      this.visible = false
      this.closeReason = ''
    }
  }
}
</script>

<style scoped>

</style>
